export const TabTypes = {
    Selection: 0,
    Summary: 1
};
